import TokenService from "../services/authentication/token.service.ts";

export const handleErrorResponse = (error: any) => {
  if (error.response) {
    const { status } = error.response;

    switch (status) {
      case 400:
        return "Bad Request: Invalid input value. Please check your request.";

      case 401:
        TokenService.removeUser();
        if (window.location.pathname.endsWith("/login") !== true) {
          window.location.reload();
        }
        return "Unauthorized: Authentication is required and has failed or hasn't been provided.";

      case 403:
        return "Forbidden: You do not have permission to perform this action.";

      case 404:
        return "Not Found: The requested resource could not be found.";

      case 409:
        return "Conflict: There's a conflict with the current state of the resource.";

      case 500:
        return "Internal Server Error: A generic server error occurred. Please try again later.";

      case 501:
        return "Not Implemented: The requested endpoint is not implemented or available.";

      default:
        return `Error: An unexpected error occurred. Status code: ${status}`;
    }
  }
  return "An unexpected error occurred. Please check your network connection or try again later.";
};
